export class ChatMsg{
    msg: string;
    user_name: string;
    user_avatar: string;
    created: string;
    room_id: string;
    sent_by: string;
    constructor(msg?:string, user_name?:string, user_avatar?:string, created?:string, room_id?:string, sent_by?: string){
        this.msg = msg;
        this.user_name = user_name;
        this.user_avatar = user_avatar;
        this.created = created;
        this.room_id = room_id;
        this.sent_by = sent_by;
    }
}
